import { defineClientModule, type ModuleRoute } from '@/app/module';
import { copy } from './copy';

/**
 * tournaments: round robin and knockout brackets, drawn on the phone from the shared matchmaking
 * functions. Keep this file light: data and lazy imports only. What other modules may import is in
 * public.ts.
 */
const routes: ModuleRoute[] = [
  { path: '/tournaments', screen: () => import('./screens/Tournaments'), tab: 'play' },
  { path: '/tournaments/new', screen: () => import('./screens/NewTournament'), tab: 'play' },
  { path: '/tournaments/:id', screen: () => import('./screens/Tournament'), tab: 'play' },
  { path: '/tournaments/*', screen: () => import('./screens/TournamentMore'), tab: 'play' },
];

export default defineClientModule({
  name: 'tournaments',
  routes,
  homeCards: [{ id: 'liveTournament', order: 25, component: () => import('./parts/LiveTournamentCard') }],
  playHubTiles: [
    {
      id: 'tournament',
      order: 40,
      title: 'Tournament',
      sub: copy.tile,
      to: '/tournaments',
      color: 'sky',
      icon: 'trophy',
      size: 'wide',
    },
  ],
});
